import React from "react";

import api from "lib/api";
import TasksTable from "./TasksTable";

interface Props {
	search: string;
}

const Active = ({ search }: Props) => {
	return (
		<TasksTable
			search={search}
			requestTasks={api.workflow.getActiveTasksAsAdmin}
		/>
	);
};

export default Active;
